import Bugsnag from '@bugsnag/js';

// Supabase OAuth, magic-link and recovery redirects put the session in the URL hash
// (#access_token=...&refresh_token=...&provider_token=...). The page URL, the context
// and the History breadcrumbs all carry it, so blank those values before sending; also
// URL-encoded, as in /login?redirect=%2Faccount%23access_token%3D...
const TOKEN_IN_URL = /((?:access|refresh|provider|provider_refresh)_token(?:=|%3D))(?:(?!%26|%23)[^&#\s"'])*/gi;

/** A copy of value with token values in every string blanked. Never mutates: breadcrumb
 * metadata holds the router's own history.state object. */
export function redactTokens(value, depth = 0) {
  if (typeof value === 'string') return value.replace(TOKEN_IN_URL, '$1[REDACTED]');
  if (!value || typeof value !== 'object' || depth > 6) return value;
  if (Array.isArray(value)) return value.map((v) => redactTokens(v, depth + 1));
  const copy = {};
  for (const key of Object.keys(value)) copy[key] = redactTokens(value[key], depth + 1);
  return copy;
}

function redactEvent(event) {
  if (event.request && event.request.url) event.request.url = redactTokens(event.request.url);
  event.context = redactTokens(event.context);
}

function redactBreadcrumb(breadcrumb) {
  breadcrumb.message = redactTokens(breadcrumb.message);
  breadcrumb.metadata = redactTokens(breadcrumb.metadata);
}

export function start() {
  // next.js executes top-level code at build time. See https://github.com/vercel/next.js/discussions/16840 for further example
  // So use NEXT_PHASE to avoid Bugsnag.start being executed during the build phase
  // See https://nextjs.org/docs/api-reference/next.config.js/introduction and https://github.com/vercel/next.js/blob/canary/packages/next/shared/lib/constants.ts#L1-L5 for
  // more details on NEXT_PHASE
  if (process.env.NEXT_PHASE !== 'phase-production-build') {
    if (process.env.NEXT_IS_SERVER === true) {
      Bugsnag.start({
        apiKey: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY,
        appVersion: process.env.NEXT_BUILD_ID,
        // @bugsnag/plugin-aws-lambda must only be imported on the server
        // eslint-disable-next-line
        plugins: [require('@bugsnag/plugin-aws-lambda')],
      });
    } else {
      // If preferred two separate Bugsnag projects e.g. a javascript and a node project could be used rather than a single one
      Bugsnag.start({
        apiKey: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY,
        appVersion: process.env.NEXT_BUILD_ID,
        plugins: [],
        onError: redactEvent,
        onBreadcrumb: redactBreadcrumb,
      });
    }
  }
}

export function getServerlessHandler() {
  return Bugsnag.getPlugin('awsLambda').createHandler();
}
